import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@chatterbug/aaron'
import PageWrapupSkeleton from 'src/ui/PageWrapup/PageWrapupSkeleton'

const ActivityWrapupSkeleton = ({
  activityType,
  titleSection,
  subtitleSection,
  headingSection,
  ratingSection,
  vocabularySection,
  liveLessonSection,
  practiceWritingSection,
  goalsSection,
  actionsSection,
}) => {
  return (
    // `data-activity` is for tracking
    <Box as="section" data-activity-type={activityType}>
      <PageWrapupSkeleton
        contentSection={
          <>
            {(titleSection || subtitleSection) && (
              <Box>
                {titleSection && (
                  <Box
                    as="h1"
                    variant="text.h2"
                    lineHeight={1.2}
                    maxWidth={{ _: '100%', tablet: '50%' }}
                  >
                    {titleSection}
                  </Box>
                )}
                {subtitleSection && (
                  <Box
                    variant="text.paragraph"
                    mt="1x"
                    fontSize={20}
                    lineHeight={1.2}
                  >
                    {subtitleSection}
                  </Box>
                )}
              </Box>
            )}
            {headingSection}
            {ratingSection}
            {vocabularySection}
            {liveLessonSection}
            {practiceWritingSection}
            {goalsSection}
          </>
        }
        actionsSection={actionsSection}
      />
    </Box>
  )
}

ActivityWrapupSkeleton.propTypes = {
  activityType: PropTypes.string.isRequired,
  titleSection: PropTypes.any,
  subtitleSection: PropTypes.any,
  headingSection: PropTypes.any,
  ratingSection: PropTypes.any,
  vocabularySection: PropTypes.any,
  liveLessonSection: PropTypes.any,
  practiceWritingSection: PropTypes.any,
  goalsSection: PropTypes.any,
  actionsSection: PropTypes.any,
}

export default ActivityWrapupSkeleton
